import * as React from 'react';
import { getFullName } from 'Src/helpers/autocomplete/autocomplete';

export type RelayPositionValues = Record<string, Record<string, string>>;
export const relayPlayerKey = player => `${player.userId}:${player.permissionId}`;
export function relayPositionOptions(event) {
  const sport = event.sport || {};
  const positions = sport.field?.positions || sport.positions || [];
  return (Array.isArray(positions) ? positions : []).map(position => ({
    id: String(position.id || position._id), name: position.shortName || position.name
  })).filter(position => position.id !== 'undefined' && position.name);
}
export function missingRelayPositions(event, students, values = {}) {
  if (!event.sport?.isRelay) return false;
  const options = relayPositionOptions(event);
  return options.length > 0 && students.some(student => !options.some(position => position.id === values[relayPlayerKey(student)]));
}
export function relayPositionFields(event, student, values = {}) {
  if (!event.sport?.isRelay) return {};
  const position = relayPositionOptions(event).find(option => option.id === values[relayPlayerKey(student)]);
  return position ? {positionId: position.id, positionName: position.name} : {};
}
export function RelayPositions({event, eventName, students, values, onChange}: any) {
  const options = relayPositionOptions(event);
  if (!event.sport?.isRelay || !options.length || !students.length) return null;
  return <fieldset className="relayAllocationPositions">
    <legend>Relay positions · {eventName}</legend>
    <p>Choose a position for each student in this relay before saving.</p>
    {students.map(student => {
      const key = relayPlayerKey(student);
      const id = `relay-position-${event.id}-${student.permissionId}`;
      return <div className="relayAllocationPositions__row" key={key}>
        <label htmlFor={id}><strong>{getFullName(student)}</strong><small>{student.schoolName || 'School not recorded'}</small></label>
        <select id={id} aria-label={`Position for ${getFullName(student)} in ${eventName}`} aria-required="true"
          value={values?.[key] || ''} onChange={event => onChange(key, event.target.value)}>
          <option value="">Choose position</option>
          {options.map(position => <option key={position.id} value={position.id}>{position.name}</option>)}
        </select>
      </div>;
    })}
  </fieldset>;
}
